import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api.js";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [me, setMe]       = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const m = await api.get("/api/admin/me");
            setMe(m);
        } catch {
            setMe(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = useCallback(async (username, password) => {
        await api.post("/api/admin/login", { username, password });
        await refresh();
    }, [refresh]);

    const logout = useCallback(async () => {
        try { await api.post("/api/admin/logout"); } catch { /* ignore */ }
        setMe(null);
    }, []);

    return (
        <AuthCtx.Provider value={{ me, loading, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
